import { FC, useState, createContext, useContext, useCallback } from 'react'
import {
  initialQueryRequest,
  QueryRequestContextProps,
  QueryState,
  WithChildren,
} from '../../../../../../_metronic/helpers'

const QueryRequestContext = createContext<QueryRequestContextProps<unknown>>(initialQueryRequest)

export const QueryRequestProvider: FC<WithChildren> = ({ children }) => {
  const initialState: QueryState<unknown> = {
    ...initialQueryRequest.state,
    fixedSort: [{ field: 'solicitacao', order: 'desc' }],
  }

  const [state, setState] = useState<QueryState<unknown>>(initialState)

  const updateState = useCallback((updates: Partial<QueryState<unknown>>) => {
    setState((prev) => ({
      ...prev,
      ...updates,
    }))
  }, [])

  return (
    <QueryRequestContext.Provider value={{ state, updateState }}>
      {children}
    </QueryRequestContext.Provider>
  )
}

export const useQueryRequest = <TParams = undefined,>() =>
  useContext(QueryRequestContext) as QueryRequestContextProps<TParams>
